"use strict";
var createPlayer = require("web-audio-player");
var Promise = require("promise");
var par = require("par");

var loadingMap = {};
var loadedMap = {};

var context = null;

Sound.web = "webaudio";

function Sound(fileNames, basePath, onError) {
	var fileName = fileNames[0];
	var location = basePath + fileName;

	var wasLoaded = loadedMap[location];
	var isLoading = loadingMap[location];

	if (wasLoaded) {
		this._source = wasLoaded;
		if (onError)
			onError();
	} else if (isLoading) {
		isLoading.then(handle_loaded.bind(this)).then(onError).catch(onError);
	} else {
		createSound(location).then(handle_loaded.bind(this)).then(onError).catch(onError);
	}
}

function createSound(location) {
	var source = createPlayer(location, {
		buffer: true,
		context: getContext()
	});

	var sourcePromise = new Promise(function (resolve, reject) {
		source.once("load", par(resolve, source));
		source.once("error", reject);
	}).then(function(){
		source.node.connect(source.context.destination);

		loadedMap[location] = source;
		delete loadingMap[location];

		return source;
	});

	loadingMap[location] = sourcePromise;

	return sourcePromise;
}

Sound.prototype = {
	_onEnd: [],
	_source: null,

	_shouldPlay: false,
	_shouldVolume: 0,

	isLoaded: isLoaded,
	play: play,
	pause: pause,
	stop: pause,
	setVolume: setVolume,
	setCurrentTime: setCurrentTime,
};

Sound.MAIN_BUNDLE = process.env.PUBLIC_URL;

module.exports = Sound;

function play(cb) {
	if (this.isLoaded()) {
		this._source.play();
		this._source.once("end", cb);
	} else {
		this._shouldPlay = true;
		if (cb)
			this._onEnd.push(cb);
	}

	return this;
}

function pause() {
	if(this.isLoaded()) {
		this._source.stop();
	} else{
		this._shouldPlay = false;
		this._onEnd = [];
	}

	return this;
}

function setVolume(volume) {
	if(this.isLoaded()){
		this._source.volume = volume;
	} else {
		this._shouldVolume = volume;
	}

	return this;
}

function setCurrentTime() {
	// Ha ha no

	return this;
}

function handle_loaded(source) {
	this._source = source;

	if(this._shouldVolume)
		source.volume = this._shouldVolume;

	if (this._shouldPlay)
		source.play();
}

function isLoaded(){
	return !!this._source;
}

function getContext(){
	if(!context)
		context = require("audio-context")();
	return context;
}